<template>
  <tbody>
    <tr v-for="row in items" :key="row.id" class="hovereable" @click="editItemWithEvent($event, row.status, row.id, row.type)">
      <td class="no-border text-xs-center" width="60">
        <v-avatar size="45" class="transparent">
          <v-icon large class="k-orange-linear-text" v-if="row.channel === 'sms'">fas fa-comments</v-icon>
          <v-icon large class="k-orange-linear-text" v-else-if="row.channel === 'ivr'">fas fa-phone fa-rotate-90</v-icon>
          <v-icon large class="k-orange-linear-text" v-else-if="row.channel === 'email'">fas fa-envelope</v-icon>
          <v-icon large class="k-orange-linear-text" v-else-if="row.channel === 'bot'">fas fa-robot</v-icon>
          <v-icon large class="k-orange-linear-text" v-else>fas fa-user</v-icon>
        </v-avatar>
      </td>
      <td v-if="row.user">
        {{row.user.name ? row.user.name : `${row.user.first_name ? row.user.first_name : ''} ${row.user.last_name ? row.user.last_name : ''}`}}
        <small>{{row.user.email ? row.user.email.toLowerCase() : '(Sin asignar)'}}</small>
      </td>
      <td v-else>
        <div class="grey--text">
          (Sin asignar)
        </div>
      </td>
      <td>
        {{row.name ? row.name : `${row.first_name ? row.first_name : ''} ${row.last_name ? row.last_name : ''}`}}
        <small>{{row.channel ? row.channel === 'human' ? 'Call Center' : row.channel.toUpperCase() : '(Sin asignar)'}} {{row.template_code ? `- ${row.template_code.toUpperCase()}` : ''}}</small>
      </td>
      <td>
        Tipo de entrega
        <small>{{row.delivery_option ? row.delivery_option : '(Sin asignar)'}}</small>
      </td>
      <td>
        <template v-if="row.start_date">
          {{utcToLocal(row.start_date, 'DD/MM/YYYY')}}
          <small>{{utcToLocal(row.start_date, 'h:mm A')}}</small>
        </template>
        <template v-else>
          Inicio de campaña
          <small>(Sin asignar)</small>
        </template>
      </td>
      <td class="text-xs-right">
        <v-layout row wrap>
          <v-flex md9>
            <v-chip :class="{'transparent subheading':true, 'blue--text':row.status === 'Pendiente' || row.status === 'En proceso' || row.status === 'Programada', 'orange--text':row.status === 'Por enviar', 'green--text':row.status === 'Enviada'}">
              {{row.status}}
              <v-icon class="pl-2" small v-if="row.status === 'En proceso'">fas fa-clipboard-list</v-icon>
              <v-icon class="pl-2" small v-if="row.status === 'Pendiente'">fas fa-clock</v-icon>
              <v-icon class="pl-2" small v-if="row.status === 'Por enviar'">fas fa-share</v-icon>
              <v-icon class="pl-2" small v-if="row.status === 'Enviada'">fas fa-check</v-icon>
              <v-icon class="pl-2" small v-if="row.status === 'Programada'">fas fa-cog</v-icon>
            </v-chip>
          </v-flex>
          <v-flex md3>
            <v-menu offset-x left>
              <v-btn slot="activator" icon small>
                <v-icon small>fas fa-ellipsis-v</v-icon>
              </v-btn>
              <v-list>
                <v-list-tile @click="$emit('doEvent', {event: 'generateReport', campaign: row.id, campaignName: `${row.name}`})">
                  <v-list-tile-title>Descargar</v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="deleteItem(row.id, row.name)" :disabled="row.status !== 'Pendiente' && row.status !== 'En proceso'">
                  <v-list-tile-title>Eliminar</v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="updateStatus(row.id, 'Pendiente')" v-if="row.status === 'Programada' && parseInt(formatDate(row.start_date, 'YYYY-MM-DD', 'YYYYMMDD')) > parseInt(date)">
                  <v-list-tile-title>Pendiente</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-flex>
        </v-layout>
      </td>
    </tr>
  </tbody>
</template>

<script>
import dataTableListMixin from '@/mixins/dataTableList';
import EventBus from '@/event-bus';
import moment from 'moment';

export default {
  mixins: [
    dataTableListMixin,
  ],
  props: ['items'],
  data() {
    return {
      date: moment().format('YYYYMMDD'),
    };
  },
  methods: {
    formatDate(date, typeDate, formatDate) {
      return moment(date, typeDate).format(formatDate);
    },
    utcToLocal(date, format) {
      return moment.utc(date).local().format(format);
    },
    updateStatus(id, status) {
      this.axios.patch(`/campaigns/${id}`, {
        status // eslint-disable-line
      }).then(() => {
        EventBus.$emit('update');
      }).catch((e) => { console.log(e); }); // eslint-disable-line
    },
    editItemWithEvent($event, status, id, type) {
      if ($event.target.className !== 'btn__content') {
        if (status === 'Enviada' || status === 'En proceso' || status === 'Programada') {
          this.$router.push(`/campaigns/${id}/detail`);
        } else {
          /* eslint-disable */
          if (type === 'internal') {
            this.$router.push(`/campaigns/${id}/assigned`);
          } else {
            this.$router.push(`/campaigns/${id}/confirm`);
          }
          /* eslint-disable */
        }
      }
    },
  },
};
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/campaign/CampaignList.vue